import {Brick, registerBrick} from 'olympe';
import {TimeoutMap} from '@olympeio/core';

/**
 *
 */
export default class CreateCacheMemories extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} timeout
     * @param {string} refreshRate
     * @param {function()} forwardEvent
     * @param {function(Map)} setTimeoutMap
     */
    update($, [timeout, refreshRate], [forwardEvent, setTimeoutMap]) {
        const cacheMemory = new Map();

        cacheMemory.set('currency', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('purchaseOrg', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('plant', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('baseUnit', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('materialType', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('companyCode', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('wbs', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('costCenter', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('profitCenter', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('glAccount', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('deliveryAddress', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('purchasingGroup', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('storageLocation', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('paymentTerms', new TimeoutMap(timeout, refreshRate));

        cacheMemory.set('currencyV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('purchaseOrgV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('plantV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('baseUnitV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('materialTypeV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('companyCodeV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('wbsV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('costCenterV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('profitCenterV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('glAccountV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('deliveryAddressV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('purchasingGroupV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('storageLocationV3', new TimeoutMap(timeout, refreshRate));
        cacheMemory.set('paymentTermsV3', new TimeoutMap(timeout, refreshRate));

        setTimeoutMap(cacheMemory);
        forwardEvent();
    }
}

registerBrick('0187d6cb65fdb1111958', CreateCacheMemories);
